/** Spanish (es-CO) formatting helpers shared by the admin and portal screens. */
const MESES = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
];

export const numero = (n: number) => n.toLocaleString('es-CO');

export const nombrePeriodo = (p: string) => {
  const [a = '', m = ''] = p.split('-');
  return `${MESES[Number(m) - 1] ?? m} ${a}`;
};
export const capitalizar = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/** "01/08 9:12 a. m." as in mockup screen 3 */
export const fechaHora = (iso: string | null) =>
  iso
    ? new Date(iso).toLocaleString('es-CO', {
        day: '2-digit',
        month: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
      })
    : '—';
/** "01/08/2026 5:40 a. m." as in mockup screen 2 */
export const fechaHoraLarga = (iso: string) =>
  new Date(iso).toLocaleString('es-CO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });

export const periodoActual = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

/** Last 18 periods, newest first, for the period selector. */
export const periodosRecientes = (): string[] => {
  const out: string[] = [];
  const d = new Date();
  for (let i = 0; i < 18; i++) {
    const x = new Date(d.getFullYear(), d.getMonth() - i, 1);
    out.push(`${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}`);
  }
  return out;
};
